<template>
  <div class="follow-up-records">
    <div class="records-item" :class="{ active: i == 0 }" v-for="(bean, i) in list" :key="i">
      <div class="dian"></div>
      <div class="records-title">
        {{ bean.operateDate }}【{{ bean.operateUser }}】
        {{ { '1': '即将到期', '2': '已续保', '3': '未续保' }[bean.payState] }}
      </div>
      <div class="records-desc">{{ bean.remark }}</div>
    </div>
    <nullBox v-if="list.length == 0 && !listLoading"></nullBox>
  </div>
</template>
<script>
import nullBox from '@/components/nullBox';
export default {
  components: { nullBox },
  props: {
    renewalDetail: null
  },
  data() {
    return {
      list: [],
      listLoading: false
    };
  },
  mounted() {
    this.getRecords();
  },
  methods: {
    // 获取跟进记录
    getRecords() {
      this.listLoading = true;
      this.$http({
        type: 'GET',
        url: '/api/groupPolicyRenewalRecord/queryLogList',
        data: {
          id: this.renewalDetail.id
        }
      })
        .then(res => {
          this.list = res.data;
        })
        .finally(() => {
          this.listLoading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './followUpRecords.scss';
</style>
